// extracted by mini-css-extract-plugin
export default {"illustration":"illustration__iM_3n"};